import React from 'react';
import CongestionSummary from './CongestionSummary';
import { useTranslation } from 'react-i18next';

const checkFalsyValue = value => {
    return value ? value : 0;
};

const AllCongestionSummary = ({ congestionInfo }) => {
    const { t } = useTranslation();
    return (
        <div className={'d-grid'} style={{ gridTemplateColumns: 'repeat(4,1fr)' }}>
            <CongestionSummary
                count={checkFalsyValue(congestionInfo.totalPermittedEntryCount)}
                totalCount={checkFalsyValue(congestionInfo.totalRestrictedEntryCount)}
                label={t('CongestionStatus;Total count of entries')}
            />
            <CongestionSummary
                count={checkFalsyValue(congestionInfo.totalPermittedUniqueCount)}
                totalCount={checkFalsyValue(congestionInfo.totalRestrictedUniqueCount)}
                label={t('CongestionStatus;Unique count of entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(congestionInfo.totalAvgStayEntryTime)}
                label={t('CongestionStatus;Average length of stay of total entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(congestionInfo.totalAvgStayUniqueTime)}
                label={t('CongestionStatus;Average length of stay of unique entries')}
            />
        </div>
    );
};

export default AllCongestionSummary;
